import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Kids sweatshirt, Green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Färg",
                            value: "Grön",
                        },
                        {
                            type: "Storlek",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Kids sweatshirt, Green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Grön",
                        },
                        {
                            type: "Storlek",
                            value: "92",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Kids sweatshirt, Green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Grön",
                        },
                        {
                            type: "Storlek",
                            value: "98",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Kids sweatshirt, Black.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Svart",
                        },
                        {
                            type: "Storlek",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Kids sweatshirt, Black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Svart",
                        },
                        {
                            type: "Storlek",
                            value: "92",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Kids sweatshirt, Black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Svart",
                        },
                        {
                            type: "Storlek",
                            value: "98",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Kids sweatshirt, Pink.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Rosa",
                        },
                        {
                            type: "Storlek",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/Kids sweatshirt, Pink.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Rosa",
                        },
                        {
                            type: "Storlek",
                            value: "98",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Kids socks, Blue.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Färg",
                            value: "Blå",
                        },
                        {
                            type: "Storlek",
                            value: "22-24",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Kids socks, Blue.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Blå",
                        },
                        {
                            type: "Storlek",
                            value: "25-27",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Kids socks, Blue.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Färg",
                            value: "Blå",
                        },
                        {
                            type: "Storlek",
                            value: "28-30",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Kids socks, Pink.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Färg",
                            value: "Rosa",
                        },
                        {
                            type: "Storlek",
                            value: "22-24",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Kids socks, Green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Grön",
                        },
                        {
                            type: "Storlek",
                            value: "22-24",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Kids jacket, Green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Färg",
                            value: "Grön",
                        },
                        {
                            type: "Storlek",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Kids jacket, Green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Grön",
                        },
                        {
                            type: "Storlek",
                            value: "92",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Kids jacket, Green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Grön",
                        },
                        {
                            type: "Storlek",
                            value: "98",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Kids jacket, Blue.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Blå",
                        },
                        {
                            type: "Storlek",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Kids jacket, Blue.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Blå",
                        },
                        {
                            type: "Storlek",
                            value: "92",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Kids jacket, Blue.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Blå",
                        },
                        {
                            type: "Storlek",
                            value: "98",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Kids jacket, Pink.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Rosa",
                        },
                        {
                            type: "Storlek",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/Kids jacket, Pink.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Rosa",
                        },
                        {
                            type: "Storlek",
                            value: "92",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/Kids jacket, Pink.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Färg",
                            value: "Rosa",
                        },
                        {
                            type: "Storlek",
                            value: "98",
                        },
                    ],
                },
            ],
        };
    }
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Randig tröja",
                imageSrc: "/mocks/Kids sweatshirt, Pink.jpeg",
                imageAlt: "/mocks/Kids sweatshirt, Pink.jpeg",
                quantity: 1,
                purchasePrice: 249,
                properties: [
                    {
                        type: "Storlek",
                        value: "92",
                    },
                    {
                        type: "Färg",
                        value: "Rosa",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "2-pack randiga strumpor",
                imageSrc: "/mocks/Kids socks, Pink.jpeg",
                imageAlt: "/mocks/Kids socks, Pink.jpeg",
                quantity: 1,
                purchasePrice: 99,
                properties: [
                    {
                        type: "Färg",
                        value: "Rosa",
                    },
                    {
                        type: "Storlek",
                        value: "25-27",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "Skaljacka vattentät",
                imageSrc: "/mocks/Kids jacket, Green.jpeg",
                imageAlt: "/mocks/Kids jacket, Green.jpeg",
                quantity: 1,
                purchasePrice: 899,
                properties: [
                    {
                        type: "Storlek",
                        value: "92",
                    },
                    {
                        type: "Färg",
                        value: "Grön",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
